export default "__VITE_ASSET__ab395b9d__"